module.exports = {
          srcSet: __webpack_public_path__ + "public/bd9ec81dd9e573bc71cda6b481108757-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/bd9ec81dd9e573bc71cda6b481108757-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/bd9ec81dd9e573bc71cda6b481108757-80.png",
          toString:function(){return __webpack_public_path__ + "public/bd9ec81dd9e573bc71cda6b481108757-80.png"},
          
          width: 80,
          height: 80
        }